/** @jsx jsx */
import { Button, Grid, Heading, Stack } from "@eworkit/iris";
import { PublicProfile, NewsItem } from "data/public-profiles";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { jsx } from "theme-ui";

import { ResponsiveCard } from "@/components/ResponsiveCard";
import { NewsWidgetCard } from "@/views/Clients/News/NewsWidgetCard";
import { router } from "@/views/router";

interface PublicProfileNewsWidgetProps {
  news: NewsItem[];
  newsCount: number;
  publicProfile: PublicProfile;
  header: string;
  isPublic?: boolean;
}

export const PublicProfileNewsWidget: FC<PublicProfileNewsWidgetProps> = ({
  publicProfile,
  header,
  news,
  newsCount,
  isPublic,
}) => {
  const { t } = useTranslation("public");

  const baseRoute = isPublic ? "public-client" : "client";

  return (
    <ResponsiveCard>
      <Stack gap="md">
        <Heading size="h-sm">{header}</Heading>

        <Grid columns={["1fr", null, null, "1fr 1fr"]}>
          {news.map(n => (
            <NewsWidgetCard
              key={n.id}
              linkTo={router.get(`${baseRoute}.news-detail`, { slug: publicProfile.slug, newsId: n.id }).path}
              lineClamp={3}
              news={n}
            />
          ))}
        </Grid>

        {newsCount > 2 && (
          <Button as={Link} to={router.get(`${baseRoute}.news`, { slug: publicProfile.slug }).path} variant="secondary">
            {t("CLIENT_PAGE.NEWS.BUTTON_VIEW_ALL_NEWS")}
          </Button>
        )}
      </Stack>
    </ResponsiveCard>
  );
};
